/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import Loadable from 'react-loadable';
import CoreException from './Error';
import { Loading } from '../components/Loading';

const getComponent = loader => ({
  loader,
  loading: props => {
    if (props.error) {
      return <CoreException desc={props.error.toString()} />;
    } else if (props.timedOut) {
      return (
        <CoreException
          desc="页面加载超时"
          onBtnClick={() => {
            window.location.reload();
          }}
          btnText="点我重试"
        />
      );
    } else if (props.pastDelay) {
      return <Loading />;
    } else {
      return null;
    }
  }
});

const routes = [
  {
    path: '/h5_fe_article/html/',
    title: 'h5_fe_article首页',
    exact: true,
    strict: true, // 为了使用serviceWorker，这里必须为true，因为如果使用/h5_fe_article/html 这个路径sw不会生效
    component: Loadable(
      getComponent(() =>
        import(
          /* webpackChunkName: "DemoIndex" */ 'pages/Demo/pages/Index/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_article/html/article/index',
    title: '文章知识首页',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "articleIndex" */ 'pages/Article/pages/Index'
                )
        )
    )
  },
  {
    path: '/h5_fe_article/html/article/home',
    title: '文章列表页',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "articleHome" */ 'pages/Article/pages/HomeList'
                )
        )
    )
  },
  {
    path: '/h5_fe_article/html/article/replydetail',
    title: '文章知识评论',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "articleReplyDetail" */ 'pages/Article/pages/ReplyDetail'
                )
        )
    )
  },
  {
    path: '/h5_fe_article/html/earlyeducation/index',
    title: '早教列表页',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "earlyEducationIndex" */ 'pages/EarlyEducation/pages/Index'
                )
        )
    )
  },
  {
    path: '/h5_fe_article/html/earlyeducation/detail',
    title: '早教详情',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "earlyEducationDetail" */ 'pages/EarlyEducation/pages/Detail'
                )
        )
    )
  },
  {
    path: '/h5_fe_article/html/article/repicescommon/index',
    title: '食谱评论页',
    exact: true,
    component: Loadable(
        getComponent(() =>
            import(
                /* webpackChunkName: "articleRepicesCommon" */ 'pages/Article/pages/RepicesCommon'
                )
        )
    )
  },
  {
    path: '*',
    title: '抱歉，您访问的页面不存在！',
    component: require('core/Error/404').default
  }
];

export default routes;
